import { State } from "common/types/redux";

import { makeCrudStateSelectors } from "seneca-common/utils/apiStates";

import {
  childClassEnrollmentsCrudConfig,
  classEnrollmentsCrudConfig
} from "../consts";
import { getClassEnrollmentsSlice } from "./";

const getClassEnrollmentsMetaSlice = (state: State) =>
  // @ts-ignore
  getClassEnrollmentsSlice(state).get("meta").get("studentClassEnrollments");

const getChildClassEnrollmentsMetaSlice = (state: State) =>
  // @ts-ignore
  getClassEnrollmentsSlice(state).get("meta").get("childClassEnrollments");

const classEnrollmentCrudStateSelectors = makeCrudStateSelectors(
  // @ts-ignore
  getClassEnrollmentsMetaSlice,
  classEnrollmentsCrudConfig
);

const childClassEnrollmentsCrudStateSelectors = makeCrudStateSelectors(
  // @ts-ignore
  getChildClassEnrollmentsMetaSlice,
  childClassEnrollmentsCrudConfig
);

// FETCH ALL
export const getFetchClassEnrollmentsStarted = (state: State): boolean =>
  classEnrollmentCrudStateSelectors.fetchAll.getStarted(state);

export const getFetchClassEnrollmentsSuccess = (state: State): boolean =>
  classEnrollmentCrudStateSelectors.fetchAll.getSuccess(state);

export const getFetchClassEnrollmentsError = (state: State): boolean =>
  classEnrollmentCrudStateSelectors.fetchAll.getError(state);

export const getFetchClassEnrollmentsLastFetched = (
  state: State
): string | null | undefined =>
  classEnrollmentCrudStateSelectors.fetchAll.getLast(state);

export const classEnrollmentsHaveFinishedFetching = (state: State): boolean =>
  getFetchClassEnrollmentsError(state) ||
  getFetchClassEnrollmentsSuccess(state);

// FETCH
export const getFetchClassEnrollmentStarted = (
  state: State,
  classId: string
): boolean =>
  classEnrollmentCrudStateSelectors.fetch.getStarted(state, classId);

export const getFetchClassEnrollmentSuccess = (
  state: State,
  classId: string
): boolean =>
  classEnrollmentCrudStateSelectors.fetch.getSuccess(state, classId);

export const getFetchClassEnrollmentError = (
  state: State,
  classId: string
): boolean => classEnrollmentCrudStateSelectors.fetch.getError(state, classId);

// CREATE
export const getCreateClassEnrollmentsTimestamp = (
  state: State,
  classId: string
): string | null | undefined =>
  classEnrollmentCrudStateSelectors.create.getLast(state, classId);

export const getCreateClassEnrollmentsErrorMessage = (
  state: State,
  classId: string
): string | null | undefined =>
  classEnrollmentCrudStateSelectors.create.getErrorMessage(state, classId);

// DELETE
export const getDeleteClassEnrollmentsStarted = (
  state: State,
  classId: string
): boolean =>
  classEnrollmentCrudStateSelectors.delete.getStarted(state, classId);

export const getDeleteClassEnrollmentsSuccess = (
  state: State,
  classId: string
): boolean =>
  classEnrollmentCrudStateSelectors.delete.getSuccess(state, classId);

export const getDeleteClassEnrollmentsError = (
  state: State,
  classId: string
): boolean => classEnrollmentCrudStateSelectors.delete.getError(state, classId);

// FETCH
export const getFetchChildClassEnrollmentsAreFetching = (
  state: State,
  userId: string
): boolean =>
  childClassEnrollmentsCrudStateSelectors.fetch.getStarted(state, userId);

export const getFetchChildClassEnrollmentsSucceeded = (
  state: State,
  userId: string
): boolean =>
  childClassEnrollmentsCrudStateSelectors.fetch.getSuccess(state, userId);

export const getFetchChildClassEnrollmentsErrored = (
  state: State,
  userId: string
): boolean =>
  childClassEnrollmentsCrudStateSelectors.fetch.getError(state, userId);

export const getFetchChildClassEnrollmentsFinished = (
  state: State,
  userId: string
): boolean =>
  getFetchChildClassEnrollmentsSucceeded(state, userId) ||
  getFetchChildClassEnrollmentsErrored(state, userId);
